var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6696 6.34988V2.09988C10.6696 1.66988 10.3196 1.32988 9.89961 1.32988H5.64961L5.62961 1.13988C5.58961 0.819878 5.58961 0.499878 5.62961 0.189878L5.64961 -0.00012207H9.90961C10.4396 -0.00012207 10.9196 0.199878 11.2796 0.519878C11.3196 0.549878 11.3596 0.589878 11.3896 0.619878C11.4196 0.649878 11.4596 0.699878 11.4896 0.729878C11.8096 1.09988 11.9996 1.57988 11.9996 2.09988V6.35988L11.8096 6.37988C11.4996 6.40988 11.1796 6.40988 10.8596 6.37988L10.6696 6.35988V6.34988Z",
    fill: "#DADADC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33 5.63001V9.89001C1.33 10.32 1.68 10.66 2.1 10.66H6.35L6.37 10.85C6.41 11.17 6.41 11.49 6.37 11.8L6.35 11.99H2.1C1.57 11.99 1.09 11.79 0.73 11.47C0.69 11.44 0.65 11.4 0.62 11.37C0.59 11.34 0.55 11.29 0.52 11.26C0.2 10.89 0 10.41 0 9.88001V5.62001L0.19 5.60001C0.5 5.57001 0.82 5.57001 1.14 5.60001L1.33 5.62001V5.63001Z",
    fill: "#DADADC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.38 11.805C6.42 11.485 6.42 11.175 6.38 10.855L6.36 10.665H2.27L5.99 6.935L5.05 5.995L1.33 9.715V5.625L1.14 5.605C0.82 5.565 0.5 5.575 0.19 5.605L0 5.625V9.895C0 10.425 0.2 10.895 0.52 11.275L0.63 11.385L0.74 11.495C1.11 11.805 1.59 12.005 2.11 12.005H6.37L6.39 11.815L6.38 11.805Z",
    fill: "#DADADC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.61961 1.135L5.63961 1.325H9.71961L5.99961 5.045L6.93961 5.98499L10.6696 2.255V6.335L10.8596 6.355C11.1796 6.385 11.4996 6.385 11.8096 6.355L11.9996 6.335V2.095C11.9996 1.575 11.8096 1.095 11.4896 0.724995C11.4596 0.694995 11.4196 0.644995 11.3896 0.614995C11.3596 0.584995 11.3196 0.544995 11.2796 0.514995C10.9196 0.194995 10.4396 -0.00500488 9.90961 -0.00500488H5.64961L5.62961 0.184995C5.58961 0.494995 5.58961 0.814995 5.62961 1.135H5.61961Z",
    fill: "#DADADC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.7cfeaf0056bd41e9179986204a1dc9b8.svg";
export { ForwardRef as ReactComponent };